import { getDate, getDay, parseISO } from 'date-fns'
import React, { FC, useEffect, useState } from 'react'

import { ScheduleByDayItem } from '../../../common/ScheduleByDayItem/ScheduleByDayItem'

import { daysOfWeek, extractDatePart, sortScheduling } from '../../../../../helpers/time'

import { RegistrationFeesType } from '../../../../../models/event-fees/event-fees.interface'
import {
  IEventScheduleInterface,
  TCustomSchedule,
} from '../../../../../models/event-scheduling/event-scheduling.interface'

interface ScheduleByDayProps {
  scheduleBy?: 'class' | 'rider'
  registrationFees?: RegistrationFeesType[] | null
  customScheduling?: IEventScheduleInterface['custom'] | null
}
export const ScheduleByDay: FC<ScheduleByDayProps> = ({
  registrationFees,
  customScheduling,
  scheduleBy,
}) => {
  const [schedules, setSchedules] = useState<{ [key: string]: TCustomSchedule[] }>({})

  useEffect(() => {
    if (registrationFees) {
      const registrationFeesChildren = registrationFees.flatMap((item) => {
        if (item?.children?.[0]) return [...item.children]
        return [item]
      })

      const sortedSchedules = sortScheduling([
        ...registrationFeesChildren,
        ...(customScheduling ?? []),
      ])

      const schedules_ = sortedSchedules.reduce((acc: any, currentEvent) => {
        const extractedDate = extractDatePart(currentEvent.startDate)
        const parsedDate = parseISO(extractedDate)
        const day = daysOfWeek[getDay(parsedDate)]
        const dayOfMonth = getDate(parsedDate)
        const date = `${day}_${dayOfMonth}`
        if (date) acc[date] = [...(acc[date] ?? []), currentEvent]
        return acc
      }, {})

      setSchedules(schedules_)
    }
  }, [registrationFees])

  return Object.keys(schedules)?.length > 0 ? (
    <>
      {Object.keys(schedules).map((schedule, index) => (
        <ScheduleByDayItem
          schedules={schedules}
          schedule={schedule}
          key={index}
          scheduleBy={scheduleBy}
        />
      ))}
    </>
  ) : (
    <div className="flex justify-center fs-5 text-SeabiscuitDark200ThemeColor">
      Please add required notes for each schedules...
    </div>
  )
}
